import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import * as TestCaseHelper from "TestManagement/Scripts/TFS.TestManagement.TestCaseExportHelper";

export interface ITestCasesExportProps {
    testCaseIds: number[];
    columnOptions: any;
    okCallBack?: (testCasesData: any) => void;
}

/**
 * Proxy component to invoke test cases export to csv parser
 */
class TestCaseExportProxyComponent extends React.Component<ITestCasesExportProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let testCasesExportHelper = new TestCaseHelper.TestCaseExportHelper();
        testCasesExportHelper.initialize(this.props.testCaseIds, this.props.columnOptions, this.props.okCallBack);
    }
}

registerLWPComponent("testcases-export-proxy-component", TestCaseExportProxyComponent);
